import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterItem } from '@/components/ui/features/library/LibraryFilter/components/FilterItem';
import { Filters } from '@/components/ui/features/library/LibraryFilter/components/Filters';
import { FilterEvents } from '@/components/ui/features/speakers/SpeakersFilter/components/FilterEvents';
import { LibraryFilter as LibraryFilterEnum } from '@/enums/LibraryFilter';

export const SpeakersFilter: FC<BoxProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Box {...props}>
      <Box h="full" overflowY="auto" layerStyle="blackScrollbar">
        <Filters allowToggle reduceMotion>
          <FilterItem title={t('hubs.speakers.filterEventsTitle')} parameter={LibraryFilterEnum.Subject}>
            <FilterEvents />
          </FilterItem>
        </Filters>
      </Box>
    </Box>
  );
};
